import type { NarrativeValuatorCompany } from '../../hooks/narrativeValuatorCompanyFragment';

export const findMostRecentFiscalData = (
  timeSeries: NarrativeValuatorCompany['timeSeries'],
  today: Date = new Date()
): NarrativeValuatorCompany['timeSeries'][number] | null => {
  if (!timeSeries || timeSeries.length === 0) {
    return null;
  }

  let minDifference = Infinity;
  let mostRecentFiscalData:
    | NarrativeValuatorCompany['timeSeries'][number]
    | null = null;

  Array.from(timeSeries).forEach((data) => {
    const currentFiscalEndDate = new Date(data.date as string);

    const difference = Math.abs(
      today.getTime() - currentFiscalEndDate.getTime()
    );

    if (difference < minDifference) {
      minDifference = difference;
      mostRecentFiscalData = data;
    }
  });

  return mostRecentFiscalData;
};
